<script setup lang="ts">
import type { SectionSuggestion } from "../mention/types";
import type { CommandItemBaseProps } from "./types";
import { computed } from "vue";
import SectionSuggestionListItem from "../mention/SectionSuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps & {
  id: string;
  name: string;
}>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ onlyIfEmpty: true }))
    .setCanvasScreenshot({
      objectId: props.id,
    })
    .run();
}

defineExpose({ run });

const item = computed(() => {
  return {
    id: props.id,
    name: props.name,
    aliasName: "section",
  } as SectionSuggestion;
});
</script>

<template>
  <SectionSuggestionListItem
    :item="item"
    @click="run"
    @pointerdown.prevent
    @keydown.enter="run"
  >
    {{ name }}
  </SectionSuggestionListItem>
</template>
